const user = {
    namespaced: true,
    state: {
        user:{
            id:2,
            balance:0,
            username:'',
            phone:'',
            real_name:'',
            url:''
        },
        userInfo:{
            // id:18
        },
        balance:0,
        config : {
            title:'字节跳动公益',
            tip:'For a better life',
            header:true,
            footer:true,
            nav:1
        }
    },
    mutations: {
        // 初始化
        initUser(state, user) {
            state.user = user;
        },
        initUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        initBalance(state, balance) {
            state.balance = balance;
        },
        initConfig(state, config) {
            state.config = config;
        },
    },
    actions:{
 
        addPlus(context){

            context.commit('add')

        }
    }
};
export default user;
